// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3QRu8","fileBtn":"File_fileBtn__2vjXn","closeBtn":"File_closeBtn__23IGU","fileSelected":"File_fileSelected__1cB2Y","disabled":"File_disabled___g990"};